import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TrackingService } from '@client-libs';

@Component({
  imports: [RouterModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  private readonly trackingService = inject(TrackingService);
  private baseUrl = 'http://localhost:3000';

  constructor() {
    this.trackingService.trackVisitor(this.baseUrl);
  }
}
